/* eslint-disable */
import * as Router from "vue-router";
import { glueConfig as GLUE_CONFIG } from "../config/user-config";
import {
  Auth,
  DatasetDetailsDataset,
  MapBasic,
  MapBoundsReceiver,
  Imprint,
  PrivacyPolicy,
} from "@piveau/piveau-hub-ui-modules";
import NotFound from "./pages/NotFound.vue";
import CommentsModeration from "./pages/CommentsModeration.vue";
import AdvancedSearch from "./components/advanced-search/AdvancedSearch.vue";
import { LoginRedirect } from "@deu/piveau-hub-ui-plugin-auth";
import Combined from "@/components/search/combined/Combined";
import DatasetDiffDetails from "./components/datasetDetails/DatasetDiffDetails.vue";
import ECDatasetDetailsDataset from "./components/datasetDetails/ECDatasetDetailsDataset.vue";
import EmbedDataset from "./components/embed/EmbedDataset.vue";
import EmbedDatasetSnippet from "./components/embed/EmbedDatasetSnippet.vue";
import DatasetsCatalogue from "./components/search/datasets/DatasetsCatalogue.vue";
import ECDatasetDetailsSmiliarDatasets from "./components/datasetDetails/ECDatasetDetailsSmiliarDatasets.vue";

// Load components
const Datasets = () =>
  import(
    /* webpackChunkName: "Datasets" */ /* webpackPrefetch: false */ "@/components/search/datasets/Datasets"
  );
const Catalogues = () =>
  import(
    /* webpackChunkName: "Catalogues" */ /* webpackPrefetch: false */ "@/components/search/catalogues/Catalogues"
  );
const EditorialContent = () =>
  import(
    /* webpackChunkName: "EditorialContent" */ /* webpackPrefetch: false */ "@/components/search/editorial-content/EditorialContent"
  );
const Dataservices = () =>
  import(
    /* webpackChunkName: "Dataservices" */ /* webpackPrefetch: false */ "@/components/search/dataservices/Dataservices"
  );
const datasetseries = () =>
  import(
    /* webpackChunkName: "datasetseries" */ /* webpackPrefetch: false */ "@/components/search/datasetseries/Datasetseries"
  );
const datasetseriesDetails = () =>
  import(
    /* webpackChunkName: "DatasetseriesDetails" */ "@/components/search/datasetseries/DatasetseriesDetails.vue"
  );
const datasetseriesDetailsDataset = () =>
  import(
    /* webpackChunkName: "DatasetseriesDetailsDataset" */ "@/components/search/datasetseries/DatasetseriesDetailsDataset.vue"
  );
const DataserviceDetails = () =>
  import(
    /* webpackChunkName: "DataserviceDetails" */ "@/components/search/dataservices/DataserviceDetails.vue"
  );
const DataserviceDetailsDataset = () =>
  import(
    /* webpackChunkName: "DataserviceDetailsDataset" */ "@/components/search/dataservices/DataserviceDetailsDataset.vue"
  );
const ECDatasetDetailsQuality = () =>
  import(
    /* webpackChunkName: "ECDatasetDetailsQuality" */ /* webpackPrefetch: false */ "@/components/datasetDetails/ECDatasetDetailsQuality"
  );
const ECSparqlSearch = () =>
  import(
    /* webpackChunkName: "ECSparqlSearch" */ /* webpackPrefetch: false */ "@/components/ECSparqlSearch.vue"
  );
const DatasetDetailsSimilarDatasets = () =>
  import(
    /* webpackChunkName: "DatasetDetailsSimilarDatasets" */ "@/components/datasetDetails/ECDatasetDetailsSmiliarDatasets.vue"
  );
const DatasetDetailsCategories = () =>
  import(
    /* webpackChunkName: "DatasetDetailsCategories" */ "@/components/datasetDetails/DatasetDetailsCategories"
  );

const DatasetDetails = () =>
  import(
    /* webpackChunkName: "DatasetDetails" */ /* webpackPrefetch: false */ "./components/DatasetDetails.vue"
  );
const DatasetHistory = () =>
  import(
    /* webpackChunkName: "DatasetDetails" */ /* webpackPrefetch: false */ "./components/DatasetHistory.vue"
  );

// Load all DPI components in a dedicated chunk
const DataProviderInterface = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/DataProviderInterface"
  );
const OverviewPage = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/OverviewPage"
  );
const InputPage = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/InputPage"
  );
const DraftsPage = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/DraftsPage"
  );
const LinkedDataViewer = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/LinkedDataViewer"
  );
const UserProfilePage = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/UserProfilePage"
  );
const UserCataloguesPage = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/UserCataloguesPage"
  );
const DataFetchingComponent = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/DataFetchingComponent"
  );
const CatalogueMQA = () =>
  import(
    /* webpackChunkName: "DataProviderInterface" */ "@/components/data-provider-interface/CatalogueMQA"
  );

const rootBreadcrumb = [
  {
    text: "Home",
    to: null,
    href: "/",
  },
];

const router = Router.createRouter({
  history: Router.createWebHistory(GLUE_CONFIG.routing.routerOptions.base),
  linkActiveClass: "active",
  // mode: GLUE_CONFIG.routing.routerOptions.mode,
  scrollBehavior(to, from, savedPosition) {
     if (to.name === 'AdvancedSearch') {
     return savedPosition || false;
    }
    if (to.meta.ignoreScroll) return savedPosition;
    if (to.matched.some((route) => route.meta.scrollTop))
      return { left: 0, top: 0 };
    else if (savedPosition) return savedPosition;
    else return { left: 0, top: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: { name: GLUE_CONFIG.content.useCombinedSearch ? "Combined" : "Datasets" },
    },
    {
      path: "/datasets/advanced",
      name: "AdvancedSearch",
      component: AdvancedSearch,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          return [
            ...rootBreadcrumb,
            {
              text: "Advanced Search",
              to: { name: "AdvancedSearch" },
            },
          ];
        },
      },
    },
    {
      path: "/datasets",
      name: "Datasets",
      component: Datasets,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          const catalog =
            route.query?.showcatalogdetails && route.query?.catalog;
          const datasetOrCatalogBreadcrumbs = catalog
            ? [
                {
                  text: t.call(vm, "message.header.navigation.data.catalogs"),
                  to: { name: "Catalogues" },
                },
                {
                  text: langResolverFn(
                    store.getters["catalogDetails/getCatalog"]?.title
                  ),
                  to: {
                    name: "Datasets",
                    query: { showcatalogdetails: true, catalog },
                  },
                },
              ]
            : [
                {
                  text: t.call(vm, "message.header.navigation.data.datasets"),
                  to: { name: "Datasets" },
                },
              ];
          return [...rootBreadcrumb, ...datasetOrCatalogBreadcrumbs];
        },
      },
    },
    {
      path: "/datasets/:ds_id",
      component: DatasetDetails,
      children: [
        {
          path: "",
          name: "DatasetDetailsDataset",
          components: {
            datasetDetailsSubpages: ECDatasetDetailsDataset,
          },
          meta: {
            robots: "index, follow",
          },
        },
        {
          path: "categories",
          name: "DatasetDetailsCategories",
          components: {
            datasetDetailsSubpages: DatasetDetailsCategories,
          },
          meta: {
            breadcrumbs({ route, store, t, langResolverFn }) {
              const vm = this;
              return [
                {
                  text: t.call(vm, "message.metadata.categories"),
                  to: {
                    name: "DatasetDetailsCategories",
                    params: { ds_id: route.params.ds_id },
                  },
                },
              ];
            },
          },
        },
        {
          path: "similarDatasets",
          name: "DatasetDetailsSimilarDatasets",
          components: {
            datasetDetailsSubpages: DatasetDetailsSimilarDatasets,
          },
          meta: {
            robots: "noindex, follow",
            breadcrumbs({ route, store, t, langResolverFn }) {
              const vm = this;
              return [
                {
                  text: t.call(vm, "message.similarDatasets.similarDatasets"),
                  to: {
                    name: "DatasetDetailsSimilarDatasets",
                    params: { ds_id: route.params.ds_id },
                  },
                },
              ];
            },
          },
        },
        {
          path: "quality",
          name: "DatasetDetailsQuality",
          components: {
            datasetDetailsSubpages: ECDatasetDetailsQuality,
          },
          meta: {
            robots: "noindex",
            breadcrumbs({ route, store, t, langResolverFn }) {
              const vm = this;
              return [
                {
                  text: t.call(vm, "message.datasetDetails.subnav.quality"),
                  to: {
                    name: "DatasetDetailsQuality",
                    params: { ds_id: route.params.ds_id },
                  },
                },
              ];
            },
          },
        },
        {
          path: "embed",
          name: "EmbedDataset",
          components: {
            datasetDetailsSubpages: EmbedDataset,
          },
          meta: {
             robots: "noindex, nofollow",
          },
        },
        {
          path: "embed-snippet",
          name: "EmbedDatasetSnippet",
          components: {
            datasetDetailsSubpages: EmbedDatasetSnippet,
          },
          meta: {
            robots: "noindex, nofollow",
          },
        },
        {
          path: "dataset-diff-details/:selectedRevisionVersion",
          name: "DatasetDiffDetails",
          components: {
            datasetDetailsSubpages: DatasetDiffDetails,
          },
          meta: {
            ignoreScroll: true,
          },
        },
      ],
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          const datasetTitle = store.getters["datasetDetails/getTitle"];

          return [
            ...rootBreadcrumb,
            {
              text: t.call(vm, "message.header.navigation.data.datasets"),
              to: { name: "Datasets" },
            },
            {
              text: langResolverFn(datasetTitle),
              to: { name: "DatasetDetailsDataset" },
            },
          ];
        },
      },
    },
    {
      path: "/datasets/:ds_id/history",
      name: "Dataset History",
      component: DatasetHistory,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          const datasetTitle = store.getters["datasetDetails/getTitle"];
          return [
            ...rootBreadcrumb,
            {
              text: t.call(vm, "message.header.navigation.data.datasets"),
              to: { name: "Datasets" },
            },
            {
              text: langResolverFn(datasetTitle),
              to: { name: "DatasetDetailsDataset" },
            },
          ];
        },
      },
    },
    {
      path: "/catalogues",
      name: "Catalogues",
      component: Catalogues,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          return [
            ...rootBreadcrumb,
            {
              text: t.call(vm, "message.header.navigation.data.catalogs"),
              to: { name: "Catalogues" },
            },
          ];
        },
      },
    },
    // {
    //   path: "/catalogues/:ctlg_id",
    //   name: "CatalogueDetails",
    //   component: Datasets,
    //   meta: {
    //     breadcrumbs({ route, store, t, langResolverFn }) {
    //       const vm = this;
    //       return [
    //         ...rootBreadcrumb,
    //         ...[
    //           {
    //             text: t.call(vm, "message.header.navigation.data.catalogs"),
    //             to: { name: "Catalogues" },
    //           },
    //           {
    //             text: langResolverFn(
    //               store.getters["catalogDetails/getCatalog"]?.title
    //             ),
    //             to: {
    //               name: "CatalogueDetails",
    //               params: { ctlg_id: route.params.ctlg_id },
    //               query: { showcatalogdetails: true },
    //             },
    //           },
    //         ],
    //       ];
    //     },
    //   },
    // },
    {
      path: "/editorial-content",
      name: "EditorialContent",
      component: EditorialContent,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          return [
            ...rootBreadcrumb,
            {
              text: "Editorial Content",
              to: { name: "EditorialContent" },
            },
          ];
        },
      },
    },

    {
      path: "/catalogues/:ctlg_id",
      name: "CatalogueDetails",
      component: DatasetsCatalogue,
      meta: {
        hideAdvancedSearch: false,
        hideSearchScope: false,
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          return [
            ...rootBreadcrumb,
            ...[
              {
                text: t.call(vm, "message.header.navigation.data.catalogs"),
                to: { name: "Catalogues" },
              },
              {
                text: langResolverFn(
                  store.getters["catalogDetails/getCatalog"]?.title
                ),
                to: {
                  name: "CatalogueDetails",
                  params: { ctlg_id: route.params.ctlg_id },
                  query: { showcatalogdetails: true },
                },
              },
            ],
          ];
        },
      },
    },
    {
      path: "/dataservices",
      name: "Dataservices",
      component: Dataservices,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          return [
            ...rootBreadcrumb,
            {
              text: t.call(vm, "message.header.navigation.data.dataservices"),
              to: { name: "Dataservices" },
            },
          ];
        },
      },
    },
    {
      path: "/dataservices/:ds_id",
      component: DataserviceDetails,
      children: [
        {
          path: "",
          name: "DataserviceDetailsDataset",
          components: {
            datasetDetailsSubpages: DataserviceDetailsDataset,
          },
        },
        {
          path: "quality",
          name: "DataserviceDetailsQuality",
          components: {
            datasetDetailsSubpages: ECDatasetDetailsQuality,
          },
          meta: {
            robots: "noindex",
            breadcrumbs({ route, store, t, langResolverFn }) {
              const vm = this;
              return [
                {
                  text: t.call(vm, "message.datasetDetails.subnav.quality"),
                  to: {
                    name: "DataserviceDetailsQuality",
                    params: { ds_id: route.params.ds_id },
                  },
                },
              ];
            },
          },
        },
      ],
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          const datasetTitle = store.getters["dataserviceDetails/getTitle"];
          return [
            ...rootBreadcrumb,
            {
              text: t.call(vm, "message.header.navigation.data.dataservices"),
              to: { name: "Dataservices" },
            },
            {
              text: langResolverFn(datasetTitle),
              to: {
                name: "DataserviceDetailsDataset",
                params: { ds_id: route.params.ds_id },
              },
            },
          ];
        },
      },
    },
    {
      path: "/datasetseries",
      name: "datasetseries",
      component: datasetseries,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          return [
            ...rootBreadcrumb,
            {
              text: t.call(vm, "message.header.navigation.data.datasetseries"),
              to: { name: "datasetseries" },
            },
          ];
        },
      },
    },
    {
      path: "/datasetseries/:ds_id",
      component: datasetseriesDetails,
      children: [
        {
          path: "",
          name: "datasetseriesDetailsDataset",
          components: {
            datasetDetailsSubpages: datasetseriesDetailsDataset,
          },
        },
      ],
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          const datasetTitle = store.getters["datasetseriesDetails/getTitle"];
          return [
            ...rootBreadcrumb,
            {
              text: t.call(vm, "message.header.navigation.data.datasetseries"),
              to: { name: "datasetseries" },
            },
            {
              text: langResolverFn(datasetTitle),
              to: {
                name: "datasetseriesDetailsDataset",
                params: { ds_id: route.params.ds_id },
              },
            },
          ];
        },
      },
    },
    {
      path: "/combined",
      name: "Combined",
      component: Combined,
      meta: {
        breadcrumbs({ route, store, t, langResolverFn }) {
          const vm = this;
          return [
            ...rootBreadcrumb,
            {
              text: "Combined",
              to: { name: "Combined" },
            },
          ];
        },
      },
    },
    {
      path: "/imprint",
      name: "Imprint",
      component: Imprint,
    },
    {
      path: "/privacypolicy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
    },
    {
      path: "/maps",
      name: "MapBasic",
      component: MapBasic,
    },
    {
      path: "/mapsBoundsReceiver",
      name: "MapBoundsReceiver",
      component: MapBoundsReceiver,
    },
    {
      path: "/login",
      name: "Login",
      component: Auth,
    },
    {
      path: "/logout",
      name: "Logout",
      component: Auth,
    },
    {
      path: "/login-redirect",
      name: "LoginRedirect",
      component: LoginRedirect,
    },
    {
      path: "/logout-redirect",
      redirect: { name: "Datasets" },
    },
    {
      path: "/404",
      alias: "/(.)*",
      name: "NotFound",
      component: NotFound,
      meta: {
        robots: "noindex, nofollow",
      },
    },
    {
      path: "/sparql",
      name: "SparqlSearch",
      component: ECSparqlSearch,
    },
  ],
});

if (GLUE_CONFIG.content.dataProviderInterface.useService) {
  router.addRoute({
    path: "/dpi/draft",
    name: "DataProviderInterface-Draft",
    component: DraftsPage,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
        ...rootBreadcrumb,
        { text: "Datasets", to: { name: "Datasets" } },
        { text: "Draft Datasets", to: { name: "DataProviderInterface-Draft" } },
      ],
    },
  }),
    router.addRoute({
      path: "/dpi/draft/:name.:format",
      name: "DataProviderInterface-LinkedData",
      component: LinkedDataViewer,
      props: true,
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          ...rootBreadcrumb,
          { text: "Datasets", to: { name: "Datasets" } },
          {
            text: "Draft Datasets",
            to: { name: "DataProviderInterface-Draft" },
          },
          {
            text: "Linked Data",
            to: { name: "DataProviderInterface-LinkedData" },
          },
        ],
      },
    }),
    router.addRoute({
      path: "/dpi/user/",
      name: "DataProviderInterface-UserProfile",
      component: UserProfilePage,
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          ...rootBreadcrumb,
          { text: "Datasets", to: { name: "Datasets" } },
          {
            text: "User Profile",
            to: { name: "DataProviderInterface-UserProfile" },
          },
        ],
      },
    }),
    router.addRoute({
      path: "/dpi/user-catalogues",
      name: "DataProviderInterface-UserCatalogues",
      component: UserCataloguesPage,
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          ...rootBreadcrumb,
          { text: "Datasets", to: { name: "Datasets" } },
          {
            text: "My Catalogues",
            to: { name: "DataProviderInterface-UserCatalogues" },
          },
        ],
      },
    }),
    router.addRoute({
      path: "/dpi/comments-moderation",
      name: "DataProviderInterface-CommentsModeration",
      component: CommentsModeration,
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          ...rootBreadcrumb,
          { text: "Datasets", to: { name: "Datasets" } },
          {
            text: "Comments Moderation",
            to: { name: "DataProviderInterface-CommentsModeration" },
          },
        ],
      },
    }),
    router.addRoute({
      path: "/dpi/user-catalogues/settings/:id",
      name: "DataProviderInterface-MQASettings",
      component: CatalogueMQA,
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          ...rootBreadcrumb,
          {
            text: "My Catalogues",
            to: { name: "DataProviderInterface-UserCatalogues" },
          },
          {
            text: "MQA Settings",
            to: { name: "DataProviderInterface-MQASettings" },
          },
        ],
      },
    }),
    router.addRoute({
      path: "/dpi/edit/:catalog/:property/:id",
      name: "DataProviderInterface-Edit",
      component: DataFetchingComponent,
      props: true,
    }),
    router.addRoute({
      path: "/dpi",
      name: "DataProviderInterface",
      component: DataProviderInterface,
      meta: {
        requiresAuth: true,
        breadcrumbs: [
          ...rootBreadcrumb,
          {
            text: "Data Provider Interface",
            to: { name: "DataProviderInterface-Home" },
          },
        ],
      },
      children: [
        {
          path: ":property",
          name: "DataProviderInterface-Input",
          component: InputPage,
          props: true,
        },
        // {
        //   path: ":property/overview",
        //   name: "DataProviderInterface-Overview",
        //   component: OverviewPage,
        //   props: true
        // },
        // {
        //   path: ":property/:page",
        //   name: "DataProviderInterface-Input",
        //   component: InputPage,
        //   props: true,
        //   meta: {
        //     breadcrumbs({route, store, t, langResolverFn}) {
        //       const editMode = store.getters['auth/getIsEditMode'];
        //       const draftMode = store.getters['auth/getIsDraft'];
        //       const property = route.params?.property;
        //       const catalog = store.getters['dpiStore/getData'](property)['dct:catalog'];
        //       const datasetID = store.getters['dpiStore/getData'](property)['@id'];
        //       const editBreadcrumb = editMode
        //         ? [
        //             (draftMode
        //               ? {
        //                   text: datasetID,
        //                   to: { name: "DataProviderInterface-Draft" },
        //                 }
        //               : {
        //                   text: datasetID,
        //                   to: { path: `/datasets/${datasetID}` },
        //                 }
        //             ),
        //             {
        //               text: 'Edit Dataset',
        //               to: { path: `/dpi/edit/${catalog}/${property}/${datasetID}` },
        //             },
        //           ]
        //         : [
        //             {
        //               text: "Create Dataset",
        //               to: { name: "DataProviderInterface" },
        //             },
        //           ];
        //       return [
        //         ...editBreadcrumb,
        //       ];
        //     },
        //   },
        //   children: [
        //     {
        //       path: ":id",
        //       name: "DataProviderInterface-ID",
        //       component: InputPage,
        //       props: true,
        //     },
        //   ],
        // },
      ],
    });
}

router.beforeEach((to, from, next) => {
  const datasetIdRegex = /^\/datasets\/([^/]+)\.(rdf|n3|jsonld|ttl|nt)$/i;

  // Check if the URL matches the regular expression
  const match = to.path.match(datasetIdRegex);
  // if the URL matches the regular expression then console.log the dataset ID
  if (match) {
    const datasetId = decodeURIComponent(match[1]);
    const format = match[2].toLowerCase();
    // redirect to the dataset details page with query dl={format}
    // DatasetDetails will then attempt to download the dataset using the dl query parameter
    next({ path: `/datasets/${datasetId}`, query: { dl: format } });
    return;
  }

  next();
});

export default router;
